module.exports = __webpack_public_path__ + "img/monstars-1.a170a257.jpg";